type PaginationProps = {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
};

function getPages(current: number, total: number): (number | "...")[] {
    if (total <= 5) {
        return Array.from({length: total}, (_, i) => i + 1);
    }

    const pages: (number | "...")[] = [];

    // Always show first page
    pages.push(1);

    // Left ellipsis
    if (current > 3) {
        pages.push("...");
    }

    // Middle pages
    const start = Math.max(2, current - 1);
    const end = Math.min(total - 1, current + 1);

    for (let i = start; i <= end; i++) {
        pages.push(i);
    }

    // Right ellipsis
    if (current < total - 2) {
        pages.push("...");
    }

    // Always show last page
    pages.push(total);

    return pages;
}

export default function Pagination({
                                       currentPage,
                                       totalPages,
                                       onPageChange,
                                   }: PaginationProps) {
    if (totalPages < 1) return null;

    const pages = getPages(currentPage, totalPages);
    return (
        <div className="flex items-center justify-center gap-2 mt-6">
            {/* Prev */}
            <button
                disabled={currentPage === 1}
                onClick={() => onPageChange(currentPage - 1)}
                className="px-3 py-1 rounded-md border text-sm
                   disabled:opacity-50 disabled:cursor-not-allowed
                   hover:bg-gray-100"
            >
                Prev
            </button>

            {/* Page buttons */}
            {pages.map((p, idx) =>
                    p === "..." ? (
                        <span key={idx} className="px-2 text-gray-500">…</span>
                    ) : (
                        <button
                            key={idx}
                            onClick={() => onPageChange(p)}
                            className={`px-3 py-1 rounded-md text-sm border
              ${
                                p === currentPage
                                    ? "bg-gray-900 text-white border-gray-900"
                                    : "hover:bg-gray-100"
                            }`}
                        >
                            {p}
                        </button>
                    )
            )}

            {/* Next */}
            <button
                disabled={currentPage === totalPages}
                onClick={() => onPageChange(currentPage + 1)}
                className="px-3 py-1 rounded-md border text-sm
                   disabled:opacity-50 disabled:cursor-not-allowed
                   hover:bg-gray-100"
            >
                Next
            </button>
        </div>
    );
}
